export default __webpack_public_path__ + "static/brain-5c6e32b8a5a4fb885af705911f3cf651.png";